import { ParamListBase, RouteProp } from '@react-navigation/native';
import { useCallback, useEffect, useMemo } from 'react';
import { Platform } from 'react-native';

import { usePlayer } from 'components/Player/context';

type RouteParams = { screen?: string; path?: string; [key: string]: string | undefined };

type RouteMap = { [key: string]: RouteParams[] };

export const NAVBAR_ITEMS = [
  { name: 'Home', screen: 'Home', label: 'Início', params: {} },
  {
    name: 'Live',
    screen: 'Program',
    label: 'Ao Vivo',
    params: { programId: 'band-ao-vivo' },
    hideOnWeb: true,
  },
  { name: 'Videos', screen: 'Videos', label: 'Catálogo', params: { id: 'assista' } },
  { name: 'Listen', screen: 'Listen', label: 'Ouça', params: { id: 'ouca' } },
];

const useSuperiorNavbar = (route: RouteProp<ParamListBase, string>) => {
  const { reset, media } = usePlayer();
  const routeMap = useMemo(() => {
    return NAVBAR_ITEMS.reduce<RouteMap>((accumulator, currentItem) => {
      accumulator[currentItem.screen] = accumulator[currentItem.screen] || [];
      accumulator[currentItem.screen].push(currentItem.params || {});
      return accumulator;
    }, {});
  }, [NAVBAR_ITEMS]);

  useEffect(() => {
    if (!route?.path || !media?.programUrl) return;
    const checkIfMediaIsInTheSamePath = route.path === `/${media?.programUrl}`;

    if (Platform.OS === 'ios' && !checkIfMediaIsInTheSamePath) {
      reset({ media: undefined });
    }
  }, [route]);

  const hasSuperiorNavbar = useCallback(
    (currentRoute: RouteProp<ParamListBase, string>) => {
      const paramOptions = routeMap[currentRoute?.name];

      if (!paramOptions) return false;

      return paramOptions.some(
        (params) =>
          params &&
          Object.keys(params).every((key) => params[key] === (currentRoute as any)?.params?.[key])
      );
    },
    [routeMap]
  );

  return hasSuperiorNavbar(route);
};

export default useSuperiorNavbar;
